import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 26,
	viewBox: "0 0 24 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.25 1.07373C4.69365 1.07373 1 5.03926 1 9.931C1 14.8227 4.69365 18.7883 9.25 18.7883C11.2581 18.7883 13.0987 18.018 14.5293 16.7376L20.2197 22.8469C20.5126 23.1613 20.9874 23.1613 21.2803 22.8469C21.5732 22.5324 21.5732 22.0226 21.2803 21.7081L15.59 15.5989C16.7825 14.063 17.5 12.0869 17.5 9.931C17.5 5.03926 13.8063 1.07373 9.25 1.07373ZM2.5 9.931C2.5 5.92867 5.52208 2.68414 9.25 2.68414C12.9779 2.68414 16 5.92867 16 9.931C16 13.9333 12.9779 17.1779 9.25 17.1779C5.52208 17.1779 2.5 13.9333 2.5 9.931Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.00005 5.36816C5.61345 5.36816 5.30005 5.70463 5.30005 6.11969V13.2055C5.30005 13.6206 5.61345 13.957 6.00005 13.957H12.6C12.9866 13.957 13.3 13.6206 13.3 13.2055V6.11969C13.3 5.70463 12.9866 5.36816 12.6 5.36816H6.00005ZM5.90005 6.11969C5.90005 6.0604 5.94482 6.01233 6.00005 6.01233H12.6C12.6553 6.01233 12.7 6.0604 12.7 6.11969V13.2055C12.7 13.2648 12.6553 13.3129 12.6 13.3129H6.00005C5.94482 13.3129 5.90005 13.2648 5.90005 13.2055V6.11969Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.80005,
			y: 5.86816,
			width: 7,
			height: 7.58887,
			rx: .5,
			stroke: "var(--colors-grey-1)"
		})
	]
});
export default SvgView;
